import { useCallback } from 'react'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'

const InteractorProductReviewSummary = () => {
  const { t } = useTranslation()
  const reviewSummary = useCallback(
    (payload, callback) => {
      ApiService.jsonRequest('/product-review/summary', payload, (response) => {
        if (response.status_code === 200) {
          if (response.data) {
            callback(response.data)
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [t],
  )
  return { reviewSummary }
}

export default InteractorProductReviewSummary
